import { GetterTree, Getter } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { HomeState } from '@/store/types/home.state';
import Entry from "@/models/entry";

export const getters: GetterTree<HomeState, RootState> = {
    getEntries(state, type: string): Entry[] {
        return state.entries.filter((e) => e.type == type);
    }
};